import './brokerConvenienceTestSustainabilityStep.scss'
import React, { useState } from 'react'
import PropTypes from 'prop-types';
const { FormattedText } = require("core/i18n").i18n;

//Components
import { Accordion } from 'commonsComponents/accordion';
import { AccordionHeader } from 'commonsComponents/accordionHeader';
import { AccordionBody } from 'commonsComponents/accordionBody';
import BrokerConvenienceTestRadioQuestion from "../brokerConvenienceTestRadioQuestion/brokerConvenienceTestRadioQuestion";

const BrokerConvenienceTestSustainabilityStep = ({immQuestions, updateAnswer, sectionId}) => {
    const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);

    const disclaimer = (
        <div className="br-convenience-sustainability-step__disclaimer-container">
            <div className="br-convenience-sustainability-step__disclaimer-title">
                <div className="br-convenience-sustainability-step__disclaimer-icon-container">
                    <i className="br-convenience-sustainability-step__disclaimer-icon icon" />
                </div>
                <h4>
                    <FormattedText value="raSustainabilityQuestion-disclaimerText_A" />
                </h4>
                <ul className="br-convenience-sustainability-step__disclaimer-list">
                    <li>
                        <FormattedText value="raSustainabilityQuestion-disclaimerText_B" />
                    </li>
                    <li>
                        <FormattedText value="raSustainabilityQuestion-disclaimerText_C" />
                    </li>
                    <li>
                        <FormattedText value="raSustainabilityQuestion-disclaimerText_D" />
                    </li>
                </ul>
            </div>
        </div>
    )

    const immQuestion62 = immQuestions.find(immQuestion => immQuestion.get('id')==='62');
    const immAnswer65 = !!immQuestion62 && immQuestion62.get('answer').find(immAnswer => immAnswer.get('id')==='65');
    const answer65IsSelected = !!immAnswer65 && immAnswer65.get('selected') ==='S'

    const immQuestion66 = immQuestions.find(immQuestion => immQuestion.get('id')==='66');
    const immQuestion69 = immQuestions.find(immQuestion => immQuestion.get('id')==='69');
    const immQuestion73 = immQuestions.find(immQuestion => immQuestion.get('id')==='73');
    
    const buildContentFor64Answer = () => {
        return (
            <React.Fragment>
                <Accordion
                    dividerLineDown
                    isExpanded={isAccordionExpanded}
                    headerHidden={!answer65IsSelected}
                    allowSingleExpand
                    onToggle={() => setIsAccordionExpanded(!isAccordionExpanded)}
                >
                    <AccordionHeader
                        name="AccordionHeader"
                        isRightArrowPosition
                        iconStyle
                    >
                        <div className="ra-suitability-test-accordion__icon-section--separator-center">
                            {isAccordionExpanded ? (
                                <FormattedText value="raSustainabilityQuestion-accordionToggleText" />
                            ) : (
                                <FormattedText value="raSustainabilityQuestion-accordionToggleTextLess" />
                            )}
                        </div>
                    </AccordionHeader>
                    <AccordionBody name="AccordionBody">
                        <div
                            className="ra-suitability-test-factors-question__last-step-left"
                        >
                            <BrokerConvenienceTestRadioQuestion
                                key={immQuestion62.get("id")}
                                onChange={updateAnswer}
                                sectionId={sectionId}
                                answer={immQuestion62.get("answer")}
                                questionId={immQuestion62.get("id")}
                                question={immQuestion62.get("description")}
                            />
                        </div>
                    </AccordionBody>
                </Accordion>
                {answer65IsSelected && (
                    <div>
                        <BrokerConvenienceTestRadioQuestion
                            key={immQuestion66.get("id")}
                            onChange={updateAnswer}
                            sectionId={sectionId}
                            answer={immQuestion66.get("answer")}
                            questionId={immQuestion66.get("id")}
                            question={immQuestion66.get("description")}
                        />
                        <BrokerConvenienceTestRadioQuestion
                            key={immQuestion69.get("id")}
                            onChange={updateAnswer}
                            sectionId={sectionId}
                            answer={immQuestion69.get("answer")}
                            questionId={immQuestion69.get("id")}
                            question={immQuestion69.get("description")}
                        />
                        <BrokerConvenienceTestRadioQuestion
                            key={immQuestion73.get("id")}
                            onChange={updateAnswer}
                            sectionId={sectionId}
                            answer={immQuestion73.get("answer")}
                            questionId={immQuestion73.get("id")}
                            question={immQuestion73.get("description")}
                        />
                    </div>
                )}
                
            </React.Fragment>
        )
    }


    const content = answer65IsSelected ? buildContentFor64Answer() : (
        <BrokerConvenienceTestRadioQuestion
            key={immQuestion62.get("id")}
            onChange={updateAnswer}
            sectionId={sectionId}
            answer={immQuestion62.get("answer")}
            questionId={immQuestion62.get("id")}
            question={immQuestion62.get("description")}
        />
    );

    return (
        <React.Fragment>
            {disclaimer}
            {content}
        </React.Fragment>
    )
}

BrokerConvenienceTestSustainabilityStep.propTypes = {
    immQuestions: PropTypes.object,
    updateAnswer: PropTypes.func,
    sectionId: PropTypes.string
}

export default BrokerConvenienceTestSustainabilityStep
